import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar"; 
import Home from "./components/Home";
import ImageUploadSection from "./components/ImageUploadSection";
import AgriHyphenAIExplanation from "./components/AgriHyphenAIExplanation";
import Team from "./components/Team";
import Loader from "./components/Loader";
import DonatePage from "./components/DonatePage";
import Dashboard from "./components/Dashboard";
import Blogs from "./components/Blogs";
import ClimateAction from "./components/ClimateAction";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import Footer from "./components/Footer";

function LoaderWrapper({ isLoading, setIsLoading }) {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      setIsLoading(true);
      const t = setTimeout(() => setIsLoading(false), 1600);
      return () => clearTimeout(t);
    } else {
      setIsLoading(false);
    }
  }, [location, setIsLoading]);

  return isLoading ? (
    <Loader isLoading={isLoading} setIsLoading={setIsLoading} />
  ) : null;
}

// Routes that should hide the navbar entirely
const HIDE_NAVBAR_ROUTES = ["/test-ai"];

// Routes that should hide the footer.
// /test-ai is a self-contained tool with its own header and footer — the
// marketing footer stacked underneath produced two footers on that screen.
const HIDE_FOOTER_ROUTES = ["/test-ai"];

/**
 * React Router does not restore hash anchors on navigation, so links like
 * /#partners would otherwise land at the top of the homepage. Waits a frame
 * so the target section has mounted before scrolling.
 */
function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const frame = requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    });
    return () => cancelAnimationFrame(frame);
  }, [hash, pathname]);

  return null;
}

function AppContent({ isLoading, setIsLoading }) {
  const location = useLocation();
  const shouldShowNavbar = !HIDE_NAVBAR_ROUTES.includes(location.pathname);
  const shouldShowFooter = !HIDE_FOOTER_ROUTES.includes(location.pathname);

  return (
    <>
      <LoaderWrapper isLoading={isLoading} setIsLoading={setIsLoading} />
      <ScrollToHash />
      {!isLoading && shouldShowNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/test-ai" element={<ImageUploadSection />} />
        <Route path="/info" element={<AgriHyphenAIExplanation />} />
        <Route path="/team" element={<Team />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/climate-action" element={<ClimateAction />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
      </Routes>
      {!isLoading && shouldShowFooter && <Footer />}
    </>
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);
  return (
    <BrowserRouter>
      <AppContent isLoading={isLoading} setIsLoading={setIsLoading} />
    </BrowserRouter>
  );
}

export default App;
